import StreamSymbol, { StreamSymbolStrings } from 'enums/StreamSymbol'
import ProsperoPostType, { ProsperoPostTypeStrings } from 'enums/ProsperoPostType'

export const isRepost = (postType?: ProsperoPostTypeStrings, dataStream?: StreamSymbolStrings) => {
  if (!postType) {
    return false
  }

  if (dataStream === StreamSymbol.LXNXBRDCST) {
    return false
  }

  switch (postType) {
    case ProsperoPostType.TW_RETWEETS:
    case ProsperoPostType.TM_REBLOGS_W_COMMENTS:
    case ProsperoPostType.TM_REBLOGS_WO_COMMENTS:
      return true
    case ProsperoPostType.REPOST:
      if (dataStream && dataStream !== StreamSymbol.VOC) {
        return false
      }
      return true
    default:
      return false
  }
}

export default isRepost
